import * as React from "react";
const EmailIcon = ({ width = 17, height = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M11.753 14.028H5.187a.497.497 0 0 1-.492-.494c0-.27.223-.494.492-.494h6.566c1.877 0 2.79-.916 2.79-2.8V5.63c0-1.883-.913-2.799-2.79-2.799H5.187c-1.877 0-2.79.916-2.79 2.8 0 .27-.223.493-.492.493a.497.497 0 0 1-.493-.494c0-2.403 1.379-3.787 3.775-3.787h6.566c2.396 0 3.775 1.384 3.775 3.787v4.61c0 2.405-1.379 3.788-3.775 3.788"
      fill="currentColor"
    />
    <path
      d="M8.47 8.508c-.552 0-1.11-.17-1.537-.52L4.878 6.342A.494.494 0 0 1 4.8 5.65a.49.49 0 0 1 .69-.079l2.055 1.647c.499.401 1.346.401 1.845 0l2.055-1.647a.484.484 0 0 1 .69.08c.17.21.137.526-.08.69L10 7.989c-.42.35-.978.52-1.53.52m-2.626 2.884h-3.94a.497.497 0 0 1-.492-.494c0-.27.223-.494.493-.494h3.939c.269 0 .492.224.492.494s-.223.494-.492.494m-1.97-2.634h-1.97a.497.497 0 0 1-.492-.494c0-.27.223-.494.493-.494h1.97c.268 0 .492.224.492.494s-.224.494-.493.494"
      fill="currentColor"
    />
  </svg>
);
export default EmailIcon;
